var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showCarousel
        ? [
            _c(
              "carousel",
              { attrs: { selector: ".carousel-wrapper", variant: "show1" } },
              [
                _c("section", { staticClass: "carousel component standard" }, [
                  _c(
                    "div",
                    { staticClass: "carousel-wrapper show1" },
                    [_vm._t("default")],
                    2
                  ),
                ]),
              ]
            ),
          ]
        : [_vm._t("default")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }